import React from 'react'
import './Mens.css'
import Footer from '../../../component/Footer/Footer';
import LayoutWrapper from '../../../component/LayoutWrapper/';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { showProductList, doProductListingRes } from '../../../action/ProductListAction';
import { menuCategory, doMenuCategoryRes } from '../../../action/MenuCategoryAction';
import { showAltText, doAltTextRes } from '../../../action/AltTextAction';
import loaderImg from '../../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';
import ComingSoon from '../../../assets/images/coming-soon.jpg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
// import {BottomScrollListener} from 'react-bottom-scroll-listener';
import Skeleton from 'react-loading-skeleton';

class Mens extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            // cat_id: props.history.location.state.cat_id,
            // sub_id: props.history.location.state.sub_id,
            productListData: [],
            menuCategoryList: [],
            isLoader: false,
            subCatSlug: '',
            altData: '',
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    componentDidMount() {
        const altData = {}
        const data = {
            cat_id: this.props.match.params.catid,
            sub_id: this.props.match.params.subid,
            pageAdd: '1'
        }
        this.setState({
            isLoader: true
        })
        this.props.showProductList(data)
        this.props.showAltText(altData)
    }

    // handleOnDocumentBottom = () => {
    //     console.log('I am at bottom! ');
    //     const data={
    //         cat_id: this.props.match.params.catid,
    //         sub_id: this.props.match.params.subid,
    //         pageAdd: '1'          
    //     }
    //     this.setState({
    //         isLoader: true
    //     })
    //     this.props.showProductList(data)
    // };



    componentWillReceiveProps(nextProps) {
        if (nextProps.doProductListingRes && nextProps.doProductListingRes.user) {
            if (nextProps.doProductListingRes.user && nextProps.doProductListingRes.user.ProductListRes) {
                if (nextProps.doProductListingRes.user.ProductListRes && nextProps.doProductListingRes.user.ProductListRes.results === true) {
                    this.setState({
                        productListData: nextProps.doProductListingRes.user.ProductListRes.data,
                        subCatSlug: nextProps.doProductListingRes.user.ProductListRes.subCatSlug,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doMenuCategoryRes && nextProps.doMenuCategoryRes.user) {
            if (nextProps.doMenuCategoryRes.user && nextProps.doMenuCategoryRes.user.MenuCategoryRes) {
                if (nextProps.doMenuCategoryRes.user.MenuCategoryRes && nextProps.doMenuCategoryRes.user.MenuCategoryRes.result === true) {
                    this.setState({
                        menuCategoryList: nextProps.doMenuCategoryRes.user.MenuCategoryRes.category,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doAltTextRes && nextProps.doAltTextRes.user) {
            if (nextProps.doAltTextRes.user && nextProps.doAltTextRes.user.AltTextRes) {
                if (nextProps.doAltTextRes.user.AltTextRes && nextProps.doAltTextRes.user.AltTextRes.result === true) {
                    this.setState({
                        altData: nextProps.doAltTextRes.user.AltTextRes.data
                    })
                }
            }
        }
    }

    productDetails = (item) => {
        if (item.product_type === "simple" || item.product_type === "Simple") {
            if (item.sub_cat_id === '345' && this.props.match.params.catid === "21") {
                window.location.href = '/productcouplecombo/' + item.product_id + '/' + item.slug
                this.props.history.push('/productcouplecombo/' + item.product_id + '/' + item.slug, {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient,
                    slug: item.slug
                })
            } else if (this.props.match.params.catid === "16" && item.is_varient === "0") {
                window.location.href = '/product-mug-view/' + item.product_id + '/' + item.slug
                this.props.history.push({
                    pathname: `/product-mug-view/${item.product_id}/${item.slug}`,
                    state: item
                });
            } else {

                window.location.href = '/productview/' + item.product_id + '/' + item.slug + '?size=' + item.size + '&color=' + item.color.replace(" ", "+") + '&sleves=' + item.sleeve.replace(" ", "+")
                this.props.history.push({
                    pathname: `/productview/${item.product_id}/${item.slug}?size=${item.size}&color=${item.color.replace(" ", "+")}&sleves=${item.sleeve.replace(" ", "+")}`,
                    state: item
                });
                // }else{
                //     window.location.href = '/productview/'+item.product_id+'/'+item.slug+'?size=M&color='+item.color+'&sleves=Full Sleeve'
                //     this.props.history.push({
                //         pathname: `/productview/${item.product_id}/${item.slug}?size=M&color=${item.color}&sleves=Full Sleeve`,
                //         state: item
                //     });
                // }                
            }
        } else if (item.product_type === "customize") {
            // window.location.href =  '/productcupcustomize/'+item.product_id
            if (item.sub_cat_id === '12') {
                this.props.history.push('/productkeycustomize/' + item.product_id + '/' + item.slug, {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient
                })
            } else if (item.sub_cat_id === '13') {
                this.props.history.push('/productcupcustomize/' + item.product_id + '/' + item.slug, {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient
                })
            } else if (item.sub_cat_id === '343') {
                this.props.history.push('/productcombocustomize/' + item.product_id + '/' + item.slug, {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient
                })
            }


        }
        // this.props.history.push('/productview/'+item.product_id, {
        //     product_type: item.product_type,
        //     product_id:item.product_id
        // })
    }

    manMenu = (manItem) => {
        if (manItem.sub_cat.length === 0) {
            window.location.href = '/product/' + manItem.id + '/0/' + manItem.slug
            this.props.history.push('/product/' + manItem.id + '/0/' + manItem.slug, {
                sub_id: 0,
                cat_id: manItem.id
            })
        }
    }

    subMenu = (subItem) => {

        if (subItem.type === "customize") {
            if (subItem.sub_id === "10") {
                window.location.href = '/productcustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === "14") {
                window.location.href = '/productmobilecustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '11') {
                window.location.href = '/productwomencustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '17') {
                window.location.href = '/productkidscustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '13' || subItem.sub_id === '12') {
                window.location.href = '/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
                this.props.history.push('/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug, {
                    sub_id: subItem.sub_id,
                    cat_id: subItem.cat_id
                })
            }
        } else {
            window.location.href = '/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            this.props.history.push('/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug, {
                sub_id: subItem.sub_id,
                cat_id: subItem.cat_id
            })
        }
    }

    render() {
        const spinner = <span><img src={loaderImg} alt="" /></span>;

        return (
            <div className="page-wrapper">
                <LayoutWrapper />
                <Loader show={this.state.isLoader} message={spinner}>
                    <main className="main main-container">
                        {/* <div className="banner banner-cat bg-img">
                            <div className="banner-content container">
                                <h2 className="banner-subtitle">check out over <span>200+</span></h2>
                                <h1 className="banner-title">
                                    INCREDIBLE deals
                                </h1>
                                <a href="/" className="btn btn-primary">Shop Now</a>
                            </div>
                            End .banner-content
                        </div> */}
                        {/* End .banners */}
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                    <li className="breadcrumb-item"><Link to={'#'}>Product</Link></li>
                                </ol>
                            </div>
                            {/* End .container */}
                        </nav>
                        <div className="container">
                            <div className="row">
                                {/* <BottomScrollListener onBottom={this.handleOnDocumentBottom} debounce={200} offset={200}> */}

                                {/* {
                                        (scrollRef) =><div  ref={scrollRef} className="col-lg-9"> */}
                                <div className="col-lg-9">
                                    {/* <div className="marquee" > */}
                                    {
                                        this.props.match.params.catid === "1" &&
                                        <div className="alert alert-warning">
                                            <p className="noteTxt"><strong>Note :</strong> All the t-shirts are available in all 8 colours with both the sleves (half-sleves and full-sleves).</p>
                                        </div>
                                    }
                                    {
                                        this.props.match.params.catid === "17" &&
                                        <div class="alert alert-warning">
                                            <p className="noteTxt"><strong>Note :</strong> All the t-shirts are available in all 8 colours with both the sleves (half-sleves and 3/4 sleves).</p>
                                        </div>
                                    }
                                    {/* </div> */}

                                    <div className="row row-sm">
                                        {
                                            this.state.productListData && this.state.productListData.map((item, i) =>
                                                <div className="col-6 col-md-4 col-xl-3" key={i}>
                                                    <div className="product-default">
                                                        <figure>
                                                            {/* <LazyLoad height={250}> */}
                                                            {/* <div className="pointer img-wdth img-product-height" onClick={()=>this.productDetails(item)} style={{"backgroundImage": 'url('+item.photo+')'}}/> */}

                                                            {/* <img src={item.photo} alt="productImg"/>
                                                                         </LazyLoad> */}
                                                            <LazyLoadImage
                                                                alt={this.state.altData}
                                                                effect="blur"
                                                                onClick={() => this.productDetails(item)}
                                                                src={item.photo}
                                                                className="pointer"
                                                            />


                                                            {/* :
                                                                    <Skeleton highlightColor="#444" height={243}/>
                                                                    } */}
                                                        </figure>
                                                        <div className="product-details">

                                                            {/* End .product-container */}
                                                            <h2 className="product-title">
                                                                {
                                                                    item ?
                                                                        <span className="product-name">{item.name}
                                                                        </span>
                                                                        :
                                                                        <Skeleton width={50} />
                                                                }
                                                            </h2>
                                                            <div className="price-box">
                                                                <span className="old-price">
                                                                    <i className="fa fa-rupee-sign" aria-hidden="true"></i>
                                                                    {item.price || <Skeleton />}.00
                                                                </span>
                                                                <span className="product-price">
                                                                    <i className="fa fa-rupee-sign" aria-hidden="true"></i>
                                                                    {item.sale_price || <Skeleton />}.00
                                                                </span>
                                                            </div>
                                                            {/* End .price-box */}
                                                            <div className="product-action">
                                                                <button className="btn-icon btn-add-cart show-color text-white " data-toggle="modal" data-target="#addCartModal" onClick={() => this.productDetails(item)}>Show Details</button>
                                                                {/* </Link> */}
                                                            </div>
                                                        </div>
                                                        {/* End .product-details */}
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            (!this.state.productListData || this.state.productListData.length === 0) &&
                                            <img src={ComingSoon} alt="Coming Soon" className="coming-soon" />
                                        }
                                    </div>
                                </div>
                                {/* }
                                </BottomScrollListener> */}
                                {/* End .col-lg-9 */}
                                <aside className="sidebar-shop col-lg-3 order-lg-first">
                                    <div className="sidebar-wrapper">
                                        {
                                            this.state.menuCategoryList && this.state.menuCategoryList.map((item, i) => (
                                                <div className="widget" key={i}>
                                                    <h3 className="widget-title">
                                                        <div className={item.sub_cat.length > 0 ? "main-menu" : "main-cursor-menu "} data-toggle="collapse" role="button" aria-expanded="true" aria-controls="widget-body-2" onClick={() => this.manMenu(item)}>{item.cat_name}</div>
                                                    </h3>
                                                    {item.sub_cat.length > 0 &&

                                                        <div className="collapse show" id="widget-body-2">
                                                            <div className="widget-body">
                                                                <ul className="cat-list text-uppercase">
                                                                    {item.sub_cat.map((subItem, s) => (
                                                                        <li key={s}>
                                                                            <div className="sub-menu" onClick={() => this.subMenu(subItem, item.cat_name)}>{subItem.name}</div>
                                                                        </li>
                                                                    ))}

                                                                </ul>
                                                            </div>
                                                        </div>}
                                                </div>))}

                                    </div>
                                </aside>

                            </div>
                            {/* End .row */}
                        </div>
                        {/* End .container */}

                        <div className="mb-5"></div>
                        {/* margin */}
                    </main>
                </Loader>
                {/* End .main */}
                <Footer />

            </div>
        )


    }
}

Mens.propTypes = {
    doProductListingRes: PropTypes.any,
    doMenuCategoryRes: PropTypes.any,
    doAltTextRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doProductListingRes: doProductListingRes,
    doMenuCategoryRes: doMenuCategoryRes,
    doAltTextRes: doAltTextRes,
});

function mapDispatchToProps(dispatch) {
    return {
        showProductList: (data) => dispatch(showProductList(data)),
        menuCategory: (data) => dispatch(menuCategory(data)),
        showAltText: (data) => dispatch(showAltText(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Mens)
